import styled, { css } from 'styled-components';
import { ifNotProp, ifProp, switchProp } from 'styled-tools';
import media from '../../../../../../themes/media';

const Button = styled.button`
  padding: 8px 17.5px;
  display: flex;
  align-items: center;
  justify-content: center;

  height: ${switchProp('size', {
    small: '30px',
    big: '40px',
  })};

  text-align: center;

  color: ${switchProp('theme', {
    default: '#fff',
    'light-blue': '#fff',
    green: '#001947',
    cyan: '#fff',
    red: '#fff',
  })};

  background: ${switchProp('theme', {
    default: '#003765',
    'light-blue': '#215988',
    green: '#00F47F',
    cyan: '#00A4AF',
    red: '#D71A47',
  })};
  border-radius: ${switchProp('border', {
    square: '10px',
    circle: '40px',
  })};

  border: none;
  font-family: 'Founders Grotesk Mono', sans-serif;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 10px;
  line-height: 14px;
  width: 100%;

  ${ifNotProp(
    'disabled',
    css`
      :hover,
      :active,
      :focus {
        background: ${switchProp('theme', {
          default:
            'radial-gradient(86.11% 65.26% at 0% 97.26%, rgba(0, 255, 221, 0.6) 0%, rgba(0, 255, 221, 0) 100%), linear-gradient(180deg, rgba(0, 55, 101, 0.49) 0%, rgba(0, 55, 101, 0.7) 100%), #003765;',
          'light-blue':
            'radial-gradient(86.11% 65.26% at 0% 97.26%, rgba(0, 255, 221, 0.6) 0%, rgba(0, 255, 221, 0) 100%), linear-gradient(180deg, rgba(33, 89, 136, 0.49) 0%, rgba(33, 89, 136, 0.7) 100%), #215988;',
          green:
            'radial-gradient(86.11% 65.26% at 0% 97.26%, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%), linear-gradient(180deg, rgba(0, 244, 127, 0.49) 0%, rgba(0, 244, 127, 0.7) 100%), #00F47F;',
          cyan: 'radial-gradient(86.11% 65.26% at 0% 97.26%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%), #00A4AF;',
          red: 'radial-gradient(86.11% 65.26% at 0% 97.26%, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%), #D71A47;',
        })};
      }
    `
  )};

  ${ifProp(
    'disabled',
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `
  )};

  ${media.lessThan('mobileL')`
      font-size: 8px;
      line-height: 12px;
      padding: 9px 17.5px;
  `};
`;

export { Button };
